import React, { useEffect, useState, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import utils from '../../utils/utils';
import CRFComponent from '../../component/crf/crf';
import { Toast } from 'antd-mobile';
import { ApiCore } from '../../api/index';
const api = new ApiCore();

function AeScale(props: any) {

    const [formData, setFormData] = useState<any>({});

    const CrfRef: any = useRef();
    const history: any = useHistory();

    useEffect(() => {
        initData();
        getEvaluation();
        return () => {
        }
    }, [])


    const getEvaluation = () => {
        const _urlParams = utils.getUrlParams() || {};
        if (_urlParams.code) {
            let params = {
                scaleCode: _urlParams.code
            }
            api.getEvaluationInfo(params).then((res: any) => {
                if (res.code == 0 && res.data) {
                    window.document.title = res.data.cname
                }
            })
        }

    }


    const initData = () => {
        sessionStorage.setItem('alkScaleType', 'patient');
        sessionStorage.setItem('source', 'alk');
        const formData = props.formData || sessionStorage.getItem('AeScaleFormData');
        if (formData) {
            let _token: any = {};
            try {
                _token = JSON.parse(sessionStorage.getItem('token') || '{}');
            } catch (error) {
                _token = {};
            }
            let _formData: any = JSON.parse(formData);
            let __formData = {
                crfCode: _formData.crfCode,
                userCode: _token.userCode
            };
            setFormData(__formData);
        }
    }

    /**
     * 保存表单内容
     */
    const handleSave = () => {
        CrfRef.current.handleSave()
    }

    /**
      * 表单内容保存成功的回调
      * @param savedData 
      */
    const onSaveSuccess = (savedData: any) => {
        const _list = savedData?.datum || [];
        let _scorList = savedData?.datum || [];
        _scorList = _scorList.filter((v: any) => {
            if (v.key === 'result') {
                return true;
            }
        });
        let _score = _scorList[0]?.value;
        const _urlParams = utils.getUrlParams() || {};
        const _param = {
            data: JSON.stringify(_list),
            questionnaireCode: _urlParams.code,
            recordId: savedData.recordId,
            score: _score
        };
        api.toQuestionnaireRecordSave(_param).then((res: any) => {
            if (res.code == 0) {
                Toast.info('成功', 0.8);
                props.history.push(`/alk/testDetail?id=${res.data}`);
            } else {
                Toast.info(res.message || '保存失败', 0.8);
            }
        });
    }


    const goBack = () => {
        //如果是患者扫码直接进入此页面 返回登录页
        if (sessionStorage.getItem('enterType') == 'share') {
            if (utils.isMiniProgram()) {
                sessionStorage.removeItem('enterType');
                (window as any).wx.miniProgram.navigateTo({ url: `/pages/aeLogin/aeLogin` })
            } else {
                history.goBack()
            }
        } else {
            history.goBack()
        }


    }

    return (
        <div className={`${styles.aeScale_content} ${props.inPrePage ? styles.noFullScreen : styles.fullScreen}`}>
            <div className={styles.crfContent}>
                {
                    formData && Object.keys(formData).length > 0 &&
                    <CRFComponent
                        ref={CrfRef}
                        type='scale'
                        formItemSave={true}
                        params={formData}
                        onSaveSuccess={(v: any) => onSaveSuccess(v)}
                        onTransmitSuccess={() => { }}
                    />
                }
            </div>
            <div className={styles.actonBtns}>
                <div className={styles.backBtn} onClick={goBack}>返回</div>
                <div className={styles.nextBtn} onClick={handleSave}>
                    完成并提交
                </div>
            </div>
        </div>
    )

}

export default withRouter(AeScale);